import { MailboxService } from '../../../../states/mailbox/services/index';
import { Mail } from '../../../../states/mailbox/shared/mail';
import { MailboxQuery } from '../../../../states/mailbox/shared/mailbox-query';

import {
  IAugmentedJQuery,
  IComponentOptions,
  IDocumentService,
  IIntervalService,
  IScope
} from 'angular';
import { DocumentClickAbstractController } from '../../../../shared/abstract';

import './topbar-notification.component.scss';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { Subscription } from 'rxjs';

class TopbarNotificationController extends DocumentClickAbstractController {
  static $inject = [
    '$element',
    '$document',
    '$scope',
    '$interval',
    'MailboxService',
    'AuthService'
  ];

  onReadSubscription: Subscription;
  onReadManySubscription: Subscription;

  private updateInterval: number = 10000;
  private unreadCount: number;
  private updatePromise; // update emails balance interval promise

  constructor(
    $element: IAugmentedJQuery,
    $document: IDocumentService,
    $scope: IScope,
    private $interval: IIntervalService,
    private mailboxService: MailboxService,
    private authService: AuthService
  ) {
    super($element, $document, $scope);
  }

  public $onInit() {
    this.checkMail();
    this.startUpdatingEmails();
    this.onRead();
  }

  $onDestroy() {
    this.onReadSubscription.unsubscribe();
  }

  onRead() {
    this.onReadSubscription = this.mailboxService.$readEmail.subscribe((res) => {
      if (res) {
        this.unreadCount--;
      }
    });

    this.onReadManySubscription = this.mailboxService.$readMany.subscribe((res) => {
      if (res) {
        this.checkMail();
      }
    })

  }

  getTooltipMessage() {
    const msgWord = this.unreadCount === 1 ? 'message' : 'messages';
    return this.unreadCount > 0
      ? `You have ${this.unreadCount} ${msgWord} from Admin`
      : `No messages`;
  }

  private startUpdatingEmails() {
    // this.updatePromise = this.$interval( () => this.checkMail(), this.updateInterval);
  }

  private stopUpdatingEmails() {
    if (this.updatePromise) {
      this.$interval.cancel(this.updatePromise);
    }
  }

  private checkMail() {
    // check if we are logged in
    if (!this.authService.isLoggedIn()) {
      return;
    }

    this.unreadCount = 0;

    // get admin unimportant messages
    const mq: MailboxQuery = {
      page: 1,
      limit: 100,
      type: 'admin'
    };

    this.mailboxService.getMails(mq).then((mailsData) => {
      this.unreadCount += mailsData.mails.reduce(
        (unreadCount = 0, curMail: Mail) => {
          return !curMail.is_read ? unreadCount + 1 : unreadCount;
        },
        0
      );
    });
  }
}

export const TopbarNotificationComponent: IComponentOptions = {
  controller: TopbarNotificationController,
  template: require('./topbar-notification.component.html'),
  bindings: {}
};



// WEBPACK FOOTER //
// ./app/states_mobile/dashboard/components/topbar-notification/topbar-notification.component.ts